import React from 'react';
import styles from './styles.scss';
import { QRPage1, QRPage2, QRPage3 } from '../QRPages';

const QRPreview = ({ page }) => {
  const QRPages = [
    (<QRPage1 />),
    (<QRPage2 />),
    (<QRPage3 />)
  ];
  return (
    <div className={styles.qrpreview}>
      プレビュー
      {QRPages[page]}
    </div>
  );
}

export default QRPreview;
